<template>
  <fragment>
    <Title title="长者体验人数分析"></Title>
    <div class="layout-view withoutTitle pb0">
      <EchartsLayout :option="option"></EchartsLayout>
    </div>
  </fragment>
</template>

<script>
import Title from "@/components/common/Title.vue";
import EchartsLayout from "@/components/common/EchartsLayout.vue";

export default {
  components: {
    Title,
    EchartsLayout,
  },
  data() {
    return {
      option: null,
    };
  },
  methods: {},
  mounted() {
    this.option = {
      grid: { containLabel: true, left: 0, top: 30, bottom: 0, right: 0 },
      textStyle: {
        fontSize: 54,
        fontWeight: 700,
      },
      series: [
        {
          type: "line",
          symbol: "emptyCircle",
          symbolSize: 20,
          label: { show: true },
          lineStyle: { color: "RGBA(48, 148, 235, 1)" },
          itemStyle: { normal: {} },
        },
      ],
      title: {
        text: "单位：人",
        textStyle: {
          fontSize: 54,
          fontWeight: 700,
        },
      },
      tooltip: {},
      xAxis: {
        type: "category",
        axisLabel: {
          textStyle: {
            fontSize: 54,
            fontWeight: 700,
          },
        },
      },
      yAxis: {
        axisLabel: {
          textStyle: {
            fontSize: 54,
            fontWeight: 700,
          },
        },
      },
      dataset: {
        source: [
          ["Q1", 7],
          ["Q2", 6],
          ["Q3", 10],
          ["Q4", 11],
        ],
      },
    };
  },
};
</script>

<style lang="less" scoped></style>
